module.exports = __webpack_public_path__ + "assets/img/手机OEM.05c4f6f3.jpg";